import { WidgetType } from '@/types/widgetComponent.type'

// Виджеты
import widgetCpVendors from './widgets/widgetCpVendors.vue'
import widgetEmployee from './widgets/widgetEmployee.vue'
import widgetCourses from './widgets/widgetCourses.vue'
import widgetWorkplaces from './widgets/widgetWorkplaces.vue'
import widgetBriefingType from './widgets/widgetBriefingType.vue'
import widgetWork from './widgets/widgetWork.vue'
import widgetProfession from './widgets/widgetProfession.vue'
import widgetLogisticsEditable from './widgets/widgetLogisticsEditable.vue'
import widgetAnthropometries from './widgets/widgetAnthropometries.vue'
import widgetEquipCerts from './widgets/widgetEquipCerts.vue'
import widgetContractors from './widgets/widgetContractors.vue'
import widgetResponsibles from './widgets/widgetResponsibles.vue'
import widgetEmployeeSummary from './widgets/customWidgetEmployeeSummary/widgetEmployeeSummary.vue'
import EmployeeSummaryCard from './widgets/customWidgetEmployeeSummary/EmployeeSummaryCard.vue'
import { EMPLOYEE_INSURANCE_WIDGET_NAME } from './widgets/customWidgetEmployeeSummary/constants'
import widgetWorkplacePostTemplates from './widgets/workplacePostTemplates/widgetWorkplacePostTemplates.vue'
import widgetOrganizationSignatory from './widgets/widgetOrganizationSignatory.vue'

// Представление виджетов
import widgetEmployeeView from './widgets/widgetEmployeeView.vue'
import widgetBriefingView from './widgets/widgetBriefingView.vue'
import widgetHazardsView from './widgets/widgetHazardsView.vue'
import widgetCounterpartiesView from './widgets/widgetCounterpartiesView.vue'
import widgetWorkplaceView from './widgets/widgetWorkplaceView.vue'
import widgetProfessionView from './widgets/widgetProfessionView.vue'
import widgetWorkView from './widgets/widgetWorkView.vue'
import widgetFactorView from './widgets/widgetFactorView.vue'
import widgetEquipTypesView from './widgets/widgetEquipTypesView.vue'
import widgetLogisticsEditableView from './widgets/widgetLogisticsEditableView.vue'
import widgetContractorsView from './widgets/widgetContractorsView.vue'
import widgetAnthropometriesView from './widgets/widgetAnthropometriesView.vue'
import widgetEquipCertsView from './widgets/widgetEquipCertsView.vue'
import widgetCpVendorsView from './widgets/widgetCpVendorsView.vue'
import widgetResponsiblesView from './widgets/widgetResponsiblesView.vue'
import widgetWorkplacePostTemplatesView from './widgets/workplacePostTemplates/widgetWorkplacePostTemplatesView.vue'
import widgetOrganizationSignatoryView from './widgets/widgetOrganizationSignatoryView.vue'

const widgets: WidgetType[] = [
  {
    name: 'CoursesWidget',
    component: widgetCourses
  },
  {
    name: 'CounterpartiesWidget',
    component: widgetCpVendors
  },
  {
    name: 'CounterpartiesWidget2',
    component: widgetCpVendors
  },
  {
    name: 'CounterpartiesWidget3',
    component: widgetCpVendors
  },
  {
    name: 'ContractorsWidget',
    component: widgetContractors
  },
  {
    name: 'EmployeeWidget',
    component: widgetEmployee
  },
  {
    name: 'EmployeeInsuranceWidget',
    component: widgetEmployee
  },
  {
    name: 'EmployeeFullWidget',
    component: widgetEmployee
  },
  {
    name: 'WorkplaceWidget',
    component: widgetWorkplaces
  },
  {
    name: 'EmployeeExtWidget',
    component: widgetEmployee
  },
  {
    name: 'BriefingTypesWidget',
    component: widgetBriefingType
  },
  {
    name: 'HazardWidget',
    component: widgetWork
  },
  {
    name: 'WorkWidget',
    component: widgetWork
  },
  {
    name: 'FactorWidget',
    component: widgetWork
  },
  // {
  //   name: 'EquipTypesWidget',
  //   component: widgetWork
  // },
  {
    name: 'ProfessionWidget',
    component: widgetProfession
  },
  {
    name: 'EquipTypesWidget',
    component: widgetProfession
  },
  {
    name: 'EmployeeMedExamWidget',
    component: widgetEmployee
  },
  {
    name: 'LogisticsWidgetEditable',
    component: widgetLogisticsEditable
  },
  {
    name: 'LogisticsWidget',
    component: widgetLogisticsEditable
  },
  {
    name: 'AnthropometriesWidget',
    component: widgetAnthropometries
  },
  {
    name: 'EquipCertsWidget',
    component: widgetEquipCerts
  },
  {
    name: 'ResponsiblesWidget',
    component: widgetResponsibles
  },
  {
    name: 'EmployeeSummaryWidget',
    component: widgetEmployeeSummary
  },
  {
    name: 'widgetEmployeeSummaryDoc',
    component: EmployeeSummaryCard
  },
  {
    name: 'widgetEmployee2WorkplacesSummaryDoc',
    component: EmployeeSummaryCard
  },
  {
    name: 'widgetEmployeePersonalCard',
    component: EmployeeSummaryCard
  },
  {
    name: EMPLOYEE_INSURANCE_WIDGET_NAME,
    component: EmployeeSummaryCard
  },
  {
    name: 'medexamEmployeeWidget',
    component: EmployeeSummaryCard
  },
  {
    name: 'WorkplacePostTemplatesWidget',
    component: widgetWorkplacePostTemplates,
    independent: true
  },
  {
    name: 'OrganizationSignatoryWidget',
    component: widgetOrganizationSignatory
  }
]
export const getWidgets = () => widgets

const widgetsViews: WidgetType[] = [
  {
    name: 'ResponsiblesWidget',
    component: widgetResponsiblesView
  },
  {
    name: 'EmployeeWidget',
    component: widgetEmployeeView
  },
  {
    name: 'EmployeeInsuranceWidget',
    component: widgetEmployeeView
  },
  {
    name: 'EmployeeExtWidget',
    component: widgetEmployeeView
  },
  {
    name: 'EmployeeFullWidget',
    component: widgetEmployeeView
  },
  {
    name: 'BriefingTypesWidget',
    component: widgetBriefingView
  },
  {
    name: 'HazardWidget',
    component: widgetHazardsView
  },
  {
    name: 'CounterpartiesWidget',
    component: widgetCounterpartiesView
  },
  {
    name: 'CounterpartiesWidget2',
    component: widgetCpVendorsView
  },
  {
    name: 'CounterpartiesWidget3',
    component: widgetCpVendorsView
  },
  {
    name: 'ContractorsWidget',
    component: widgetContractorsView
  },
  {
    name: 'WorkplaceWidget',
    component: widgetWorkplaceView
  },
  {
    name: 'ProfessionWidget',
    component: widgetProfessionView
  },
  {
    name: 'WorkWidget',
    component: widgetWorkView
  },
  {
    name: 'FactorWidget',
    component: widgetFactorView
  },
  {
    name: 'EquipTypesWidget',
    component: widgetEquipTypesView
  },
  {
    name: 'EmployeeEducationWidget',
    component: widgetEquipTypesView
  },
  {
    name: 'EmployeeMedExamWidget',
    component: widgetEmployeeView
  },
  {
    name: 'LogisticsWidgetEditable',
    component: widgetLogisticsEditableView
  },
  {
    name: 'AnthropometriesWidget',
    component: widgetAnthropometriesView
  },
  {
    name: 'EquipCertsWidget',
    component: widgetEquipCertsView
  },
  {
    name: 'WorkplacePostTemplatesWidget',
    component: widgetWorkplacePostTemplatesView,
    independent: true
  },
  {
    name: 'OrganizationSignatoryWidget',
    component: widgetOrganizationSignatoryView
  }
]
export const getWidgetsViews = () => widgetsViews
